import React, { FC } from 'react';
import { CrewMember, RodRequestCaddy } from '@bechtel/types';
import { FieldArrayRenderProps } from 'Formik';
import { some, findIndex } from 'lodash';
import { Checkbox, Box, Text, AvatarSize } from '@bechtel/gds';
import { CaddyContainerStyled, StencilItemStyled, AvatarRegularStyled } from './styled';
import { useDate, useName } from '@bechtel/client-common';
import { map } from 'lodash';

interface BulkReturnRodRequestCaddyItemProps {
  item: RodRequestCaddy;
  fieldArrayProps: FieldArrayRenderProps;
}
export const BulkReturnRodRequestCaddyItem: FC<BulkReturnRodRequestCaddyItemProps> = ({
  item,
  fieldArrayProps: { push, remove, form },
}) => {
  const { formatISODate, formatTime } = useDate();
  const { getFullName } = useName();
  const rodCaddyList = form.values.caddyIds;

  const onClick = () => {
    const selected = findIndex(rodCaddyList, (id) => id === item.id);
    if (selected !== -1) {
      remove(selected);
    } else {
      push(item.id);
    }
  };

  const rodRequestStencils: CrewMember[] = map(item.rodRequest.stencils, (item) => item.stencil);
  return (
    <CaddyContainerStyled onClick={onClick}>
      <Box flexBasis={{ sm: '5%' }}>
        <Checkbox
          checked={some(form.values.caddyIds, (id) => {
            return item.id === id;
          })}
          readOnly
        />
      </Box>
      <Box flexDirection={{ sm: 'column' }} flexBasis={{ sm: '45%' }}>
        <Text size="500" weight="600">
          {item.caddy.label}
        </Text>
        <Text size="400" style={{ opacity: 0.7, lineHeight: 2 }}>
          {item.rodRequest.requestNumber}
        </Text>
        <Text size="300" style={{ opacity: 0.5, lineHeight: 2.3 }}>
          {formatISODate(item.issuedAt)}&nbsp;{formatTime(item.issuedAt, 'HH:m')}
        </Text>
      </Box>
      <Box flexDirection={{ sm: 'column' }} flexBasis={{ sm: '50%' }}>
        {item.rodRequest.stencils?.length > 0 &&
          map(rodRequestStencils, (stencil: CrewMember) => {
            return (
              <StencilItemStyled key={stencil.id}>
                <AvatarRegularStyled
                  hasImageUrl={stencil && stencil.imageUrl ? true : false}
                  size={AvatarSize.MEDIUM}
                  src={stencil && stencil.imageUrl ? stencil.imageUrl : undefined}
                />
                <Box flexDirection={{ sm: 'column' }} mr={{ sm: '200' }} css={{ lineHeight: '1.1' }}>
                  <Text size="400" color="grey.600" family="graphikCompact" weight="500">
                    {getFullName(stencil.firstName, stencil.lastName)}
                  </Text>
                  {stencil.badgeNumber && (
                    <Text
                      size="300"
                      color="grey.600"
                      family="graphikCompact"
                      transform="capitalize"
                      style={{ opacity: '0.7' }}
                    >
                      {stencil.badgeNumber}
                    </Text>
                  )}
                </Box>
              </StencilItemStyled>
            );
          })}
      </Box>
    </CaddyContainerStyled>
  );
};
